import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IFeedback } from '../models/feedback';

@Injectable()
export class FeedbackService {
  constructor(private http: HttpClient) { }

  submitFeedback(feedback: IFeedback): Observable<any> {
    return this.http.post<IFeedback>('/api/user/feedback', feedback);
  }
}
